import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { AppSkeletonRoutes } from './app-skeleton.routes';
import { AppRootComponent } from '@core/components/app-root/app-root.component';
import { HeaderComponent } from './components/header/header.component';
import { PageContentComponent } from './components/page-content/page-content.component';
import { FooterComponent } from './components/footer/footer.component';

// Router components
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ITCommonModule } from 'common';

@NgModule({
  imports: [
    SharedModule,
    ITCommonModule,
    RouterModule.forChild(AppSkeletonRoutes),
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [
    AppRootComponent,
    HeaderComponent,
    PageContentComponent,
    FooterComponent,
  ],
})
export class AppSkeletonModule { }
